<script>
/**
 * Mixin for integration gql with pagination in vuetify2 data-table
 */
export default {
  data () {
    return {
      gqlPagination: {
        first: null,
        last: null,
        before: null,
        after: null,
        order: null
      },
      cursors: {
        start: '',
        end: ''
      },
      viewPagination: {
        page: 1,
        itemsPerPage: 10,
        sortBy: '',
        sortDesc: true
      },
      updateGqlPagination: true
    }
  },
  watch: {
    gqlPagination: {
      deep: true,
      handler () {
        this.$emit('pagination-update')
      }
    },
    viewPagination: {
      deep: true,
      immediate: true,
      handler (pagination, oldPagination) {
        if (!this.updateGqlPagination) {
          this.updateGqlPagination = true
          return
        }
        if (pagination.sortBy) {
          this.gqlPagination.order = `${pagination.sortBy} ${(pagination.sortDesc ? 'DESC' : 'ASC')}`
        } else {
          this.gqlPagination.order = null
        }

        // Change number of items per page
        if (!oldPagination || pagination.itemsPerPage !== oldPagination.itemsPerPage) {
          this.gqlPagination.first = pagination.itemsPerPage > 0 ? pagination.itemsPerPage : null
          this.gqlPagination.last = null
          this.gqlPagination.before = null
          this.gqlPagination.after = null

          // Move a page forward
        } else if (pagination.page > oldPagination.page) {
          this.gqlPagination.first = pagination.itemsPerPage
          this.gqlPagination.last = null
          this.gqlPagination.before = null
          this.gqlPagination.after = this.cursors.end || null

          // Move a page backward
        } else if (pagination.page < oldPagination.page) {
          this.gqlPagination.first = null
          this.gqlPagination.last = pagination.itemsPerPage
          this.gqlPagination.before = this.cursors.start || null
          this.gqlPagination.after = null
        }
      }
    }
  },
  methods: {
    updateCursors ({ startCursor, endCursor }) {
      this.cursors.start = startCursor
      this.cursors.end = endCursor
    },
    sn_paginationMixin2_resetPagination (itemsPerPage = 10) {
      this.gqlPagination = {
        first: itemsPerPage,
        last: null,
        before: null,
        after: null,
        order: null
      }
      this.cursors = {
        start: '',
        end: ''
      }
      this.viewPagination = {
        page: 1,
        itemsPerPage: itemsPerPage,
        sortBy: '',
        sortDesc: true
      }
    }
  }
}
</script>
